// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.contact-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 20px;
  background-color: hsl(185, 62%, 45%);
  background-size: cover;
  background-position: center;
  max-width: 100vw;
  overflow-x: hidden;
  justify-content: space-evenly; 
  align-items: center; 
}


.info-card, .form-card, .map {
  flex: 1 1;
  min-width: 300px;
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%; /* Ensures it doesn't exceed the screen width */
  max-width: 100%; /* Prevents overflow */
}

.info-card, .form-card {
  flex: 1 1;
  max-width: 48%; 
}

@media (max-width: 768px) {
  .info-card, .form-card {
    max-width: 100%; 
  }
}
/* Description Section */
.info-description {
  padding-bottom: 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.info-description p {
  /* margin: 8px 0; */
  line-height: 1.6;
  color: #444;
}

/* Contact Details */
.info-contact {
  margin-top: 15px;
  text-align: left;
}

.info-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  padding: 8px 0;
}

.info-item span {
  font-size: 20px;
  margin-right: 10px;
}

/* .info-item strong {
  color: #007BFF;
} */

.info-item a {
  /* color: #007BFF; */
  text-decoration: none;
  font-weight: bold;
}

.info-item a:hover {
  text-decoration: underline;
}

.info-card{
    transition: all 0.3s linear;
}
.info-card:hover {
    background: var(--clr-primary-6);
    color: #fff;
  }

.info-card:hover p {
    color: var(--clr-white);
  }

  .info-card h2 {
    margin-bottom: 15px;
    color: var(--clr-grey-2);
  }
/* .leaflet-container {
  width: 100%;
  height: 100%;
} */

 textarea {
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid hsl(185, 57%, 50%);
    border-radius: 4px;
}


/* Map and Working Hours Sections Side by Side */
/* .map {
    flex: 1;
    padding: 1.5rem;
    border-radius: var(--radius);
    box-shadow: var(--light-shadow);
    transition: transform 0.3s, box-shadow 0.3s;
} */



/* Ensure proper layout */
.map {
  padding: 1.5rem;
  border-radius: var(--radius);
  box-shadow: var(--light-shadow);
  transition: transform 0.3s, box-shadow 0.3s;
  min-height: 350px; /* Prevents collapse */
  width: 100%; /* Ensures it doesn't cause overflow */
  max-width: 100%;
}

/* Ensure iframe is responsive */
.map iframe {
  width: 100%;
  height: 100%;
  min-height: 350px;
  border: 0;
  border-radius: var(--radius);
  display: block; /* Prevents extra white spaces */
}

/* Hover effects for Map and Working Hours */
.map:hover {
  transform: translateY(-5px);
  box-shadow: var(--dark-shadow);
}

.icon-hand {
  font-size: 18px;
  color: #007BFF;
  margin-right: 8px;
}

/* Responsive Fix for Mobile */
@media (max-width: 768px) {
  .contact-container {
      flex-direction: column;
      align-items: center;
      max-width: 100vw; /* Prevents overflow */
      overflow-x: hidden;
  }

  .info-card, .form-card, .map {
      width: 100%;
      min-width: unset;
      max-width: 100%;
  }

  .map {
      padding: 10px;
      min-height: 300px;
  }

  .map iframe {
      min-height: 300px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/contactUs/ContactUs.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;;AAGA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW,EAAE,+CAA+C;EAC5D,eAAe,EAAE,sBAAsB;AACzC;;AAEA;EACE,SAAO;EACP,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;AACA,wBAAwB;AACxB;EACE,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;GAEG;;AAEH;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;IAEI,2BAA2B;AAC/B;AACA;IACI,gCAAgC;IAChC,WAAW;EACb;;AAEF;IACI,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;AACF;;;GAGG;;CAEF;IACG,aAAa;IACb,mBAAmB;IACnB,oCAAoC;IACpC,kBAAkB;AACtB;;;AAGA,gDAAgD;AAChD;;;;;;GAMG;;;;AAIH,yBAAyB;AACzB;EACE,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,2CAA2C;EAC3C,iBAAiB,EAAE,sBAAsB;EACzC,WAAW,EAAE,sCAAsC;EACnD,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,4BAA4B;EAC5B,cAAc,EAAE,gCAAgC;AAClD;;AAEA,4CAA4C;AAC5C;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE;MACI,sBAAsB;MACtB,mBAAmB;MACnB,gBAAgB,EAAE,sBAAsB;MACxC,kBAAkB;EACtB;;EAEA;MACI,WAAW;MACX,gBAAgB;MAChB,eAAe;EACnB;;EAEA;MACI,aAAa;MACb,iBAAiB;EACrB;;EAEA;MACI,iBAAiB;EACrB;AACF","sourcesContent":["\n.contact-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding: 20px;\n  background-color: hsl(185, 62%, 45%);\n  background-size: cover;\n  background-position: center;\n  max-width: 100vw;\n  overflow-x: hidden;\n  justify-content: space-evenly; \n  align-items: center; \n}\n\n\n.info-card, .form-card, .map {\n  flex: 1;\n  min-width: 300px;\n  background-color: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n  width: 100%; /* Ensures it doesn't exceed the screen width */\n  max-width: 100%; /* Prevents overflow */\n}\n\n.info-card, .form-card {\n  flex: 1;\n  max-width: 48%; \n}\n\n@media (max-width: 768px) {\n  .info-card, .form-card {\n    max-width: 100%; \n  }\n}\n/* Description Section */\n.info-description {\n  padding-bottom: 15px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.info-description p {\n  /* margin: 8px 0; */\n  line-height: 1.6;\n  color: #444;\n}\n\n/* Contact Details */\n.info-contact {\n  margin-top: 15px;\n  text-align: left;\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  padding: 8px 0;\n}\n\n.info-item span {\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n/* .info-item strong {\n  color: #007BFF;\n} */\n\n.info-item a {\n  /* color: #007BFF; */\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.info-item a:hover {\n  text-decoration: underline;\n}\n\n.info-card{\n    -webkit-transition: all 0.3s linear;\n    transition: all 0.3s linear;\n}\n.info-card:hover {\n    background: var(--clr-primary-6);\n    color: #fff;\n  }\n\n.info-card:hover p {\n    color: var(--clr-white);\n  }\n\n  .info-card h2 {\n    margin-bottom: 15px;\n    color: var(--clr-grey-2);\n  }\n/* .leaflet-container {\n  width: 100%;\n  height: 100%;\n} */\n\n textarea {\n    padding: 10px;\n    margin-bottom: 10px;\n    border: 1px solid hsl(185, 57%, 50%);\n    border-radius: 4px;\n}\n\n\n/* Map and Working Hours Sections Side by Side */\n/* .map {\n    flex: 1;\n    padding: 1.5rem;\n    border-radius: var(--radius);\n    box-shadow: var(--light-shadow);\n    transition: transform 0.3s, box-shadow 0.3s;\n} */\n\n\n\n/* Ensure proper layout */\n.map {\n  padding: 1.5rem;\n  border-radius: var(--radius);\n  box-shadow: var(--light-shadow);\n  transition: transform 0.3s, box-shadow 0.3s;\n  min-height: 350px; /* Prevents collapse */\n  width: 100%; /* Ensures it doesn't cause overflow */\n  max-width: 100%;\n}\n\n/* Ensure iframe is responsive */\n.map iframe {\n  width: 100%;\n  height: 100%;\n  min-height: 350px;\n  border: 0;\n  border-radius: var(--radius);\n  display: block; /* Prevents extra white spaces */\n}\n\n/* Hover effects for Map and Working Hours */\n.map:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--dark-shadow);\n}\n\n.icon-hand {\n  font-size: 18px;\n  color: #007BFF;\n  margin-right: 8px;\n}\n\n/* Responsive Fix for Mobile */\n@media (max-width: 768px) {\n  .contact-container {\n      flex-direction: column;\n      align-items: center;\n      max-width: 100vw; /* Prevents overflow */\n      overflow-x: hidden;\n  }\n\n  .info-card, .form-card, .map {\n      width: 100%;\n      min-width: unset;\n      max-width: 100%;\n  }\n\n  .map {\n      padding: 10px;\n      min-height: 300px;\n  }\n\n  .map iframe {\n      min-height: 300px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
